<template>
  <div class="collectList">
    <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10" class="lists">
      <li @click="gotodetail(item.activityId)"
          v-for="(item,index) in activityData"
          :key="item.activityId"
          class="collectItem">
        <img :src="item.picUrl" alt="" />
        <div class="iteminfo">
          <div class="tit ellipse">{{item.activityName}}</div>
          <div class="time">{{item.activityTime}}</div>
          <div class="anthor">
            <span>主讲人：</span>
            <span class="jg">{{item.speaker}}</span>
            <span>地点：</span>
            <span>{{item.activityPlace}}</span>
          </div>
          <div class="cont">
            <span>主题：</span>
            <span>{{item.categoryName}}</span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import { Indicator } from 'mint-ui';
  import {api} from '../global/api';
    export default {
        name: "activitystudy",
      data(){
        return {
          activityData:[],
          loading:true,
          size:3,
          currentPage:1
        }
      },
      mounted(){
        this.getActivity(false);
      },
      methods: {
        loadMore() {
          // 多次加载数据
          setTimeout(() => {
            this.currentPage ++;
            this.getActivity(true);
          }, 1000);
        },
        gotodetail(id) {
          this.$router.push({
            path: 'studyDetail',
            query: {id: id}
          });
        },
        getActivity(flag) {
          Indicator.open({text: '加载中...', spinnerType: 'fading-circle'});
          const params = {activityCategory: 2,size:this.size,currentPage:this.currentPage};
          this.$http.get(api.activity, {params:params}).then(response => {
            let { success,data }=response.data;
            if(success === 1){
              Indicator.close();
              if(flag){
                // 多次加载数据
                this.activityData = this.activityData.concat(data);
                if(data.length == 0){
                  this.loading = true;
                }else{
                  this.loading = false;
                }
              }else{
                // 第一次加载数据
                this.activityData = data;
                this.loading = false;
              }
            }else{
              console.log("接口异常");
            }
          }, response => {
            console.log("请求失败了");
          })
        },
      }
    }
</script>

<style lang="scss"  scoped>
  .collectList{
    padding: 0rem .75rem 2.5rem;
  }
  .lists{
    margin: 0;
  }
   .collectItem{
     width: 17.25rem;
     height: 12.9rem;
     position: relative;
     padding: 0;
     margin:0 0 0.5rem;
   }
  .collectItem img{
    display: inline-block;
    width: 17.25rem;
    height: 12.9rem;
    border-radius: 0.5rem;
  }

  .iteminfo{
    // background-color: #666666;
    position: absolute;
    // width: 16.5rem;
    // left: 0.75rem;
    // bottom: 0.5rem;
    width: 16.25rem;
    padding: 0.5rem;
    bottom:0;
    display: block;
    color: rgba(255, 255, 255, 1);
    font-size: 0.65rem;
    font-family: PingFang-SC-Bold;
    background: -webkit-linear-gradient(rgba(0,0,0,0),rgba(0,0,0,1));
    background: -moz-linear-gradient(top,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%);; /*FireFox*/
    background: -o-linear-gradient(top,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%);  /* Opear */
    background: -ms-linear-gradient(rgba(0,0,0,0),rgba(0,0,0,1)); /*IE10及IE10+*/
    background: linear-gradient(rgba(0,0,0,0),rgba(0,0,0,1));
    // opacity: 0.8;
    .tit{
      color: #ffffff;
      font-weight: bold;
      font-size: 0.7rem;
      height: 0.8rem;
      padding-top: 1px;
    }
    .time{
      margin-top: 0.2rem;
      color: #ffffff;
      font-size: 0.65rem;
    }
    .anthor{
      margin-top: 0.2rem;
      color: #ffffff;
      font-size: 0.65rem;
      .jg{margin-right: 0.5rem}
    }
    .cont{
      margin-top: 0.2rem;
      color: #ffffff;
      font-size: 0.65rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/activitystudy.vue